<script>
/*import PublicInstitutionsByStatusWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-status/public-institutions-by-status-widget.vue";
import PublicInstitutionsByRegionWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-region/public-institutions-by-region-widget.vue";
import BaselineVsImprovedDimensionsWidget
  from "@/modules/dashboard/components/summary-information/components/baseline-vs-improved-by-dimensions-widget.vue";
import PublicInstitutionsByTerritorialLevelWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-territorial-level-widget.vue";
import PublicInstitutionsBySectorWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-sector-widget.vue";
import EmployeesBySexWidget
  from "@/modules/dashboard/components/summary-information/components/employees-by-sex/employees-by-sex-widget.vue";

import PublicInstitutionsProvidingDirectServicesWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-providing-direct-services-widget.vue";
import WidgetContainer from "@/modules/dashboard/components/summary-information/components/widget-container.vue";
import PublicInstitutionsByRegionMapWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-region/public-institutions-by-region-map-widget.vue";
import Survey from "@/modules/dashboard/components/summary-information/components/survey/survey-widget.vue";

import {onMounted, ref, watch} from "vue";
import {
  InstitutionsByStatusStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-status.store";
import {
  InstitutionsByRegionStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-region.store";
import {
  BaselineVsImprovedByDimensionsStore
} from "@/modules/dashboard/components/summary-information/stores/baseline-vs-improved-by-dimensions.store";
import {
  InstitutionsByTerritorialLevelStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-territorial-level.store";
import {
  InstitutionsBySectorStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-sector.store";
import {EmployeesBySexStore} from "@/modules/dashboard/components/summary-information/stores/employees-by-sex.store";
import {SurveyEnum} from "@/modules/dashboard/components/summary-information/model/survey.enum";
import {SurveyStore} from "@/modules/dashboard/components/summary-information/stores/survey.store";
import {
  InstitutionsDirectServicesStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-direct-services.store";
import {
  InstitutionsByCountryStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-country.store";
import {
  DashboardSelectedFiltersStore
} from "@/modules/dashboard/components/filters/stores/dashboard-selected-filters.store";
import {i18n} from "@/shared/locale/locale";
import {prepareParams} from "@/modules/dashboard/components/utils";
import {UserStore} from "@/shared/stores/user.store";
import {SubHeaderStore, SubHeaderType} from "@/shared/components/sub-header/stores/sub-header.store";
import {apiCall} from "@/shared/utils/api-call";
import {VueSpinner} from "vue3-spinners";
import {reportUrl} from "@/shared/utils/url-generator";
import router from "@/router";

var showCacheGeneration = ref(false);
var missingCache = ref(+(window as any).missingUsersCache);
var currentMissing = ref(+(window as any).missingUsersCache);
var showDashboardAsAdmin = (window as any).showDashboardAsAdmin
var isPublicInstitution = (window as any).isPublicInstitution
if(isPublicInstitution){
  router.push({ name: 'baseline-vs-improved'})
}else {
  var dashboardSelectedFiltersStore = DashboardSelectedFiltersStore();

  var institutionsByStatusStore = InstitutionsByStatusStore();
  var institutionsByRegionStore = InstitutionsByRegionStore();
  var institutionsByCountryStore = InstitutionsByCountryStore();
  var baselineVsImprovedByDimensionsStore = BaselineVsImprovedByDimensionsStore();
  var institutionsByTerritorialLevelStore = InstitutionsByTerritorialLevelStore();
  var institutionsBySectorStore = InstitutionsBySectorStore();
  var employeesBySexStore = EmployeesBySexStore();
  var surveyStore = SurveyStore();
  var institutionsDirectServicesStore = InstitutionsDirectServicesStore();

  var store = UserStore();

  var refresh = () => {
    institutionsByStatusStore.fetchInstitutionsByStatus(prepareParams());
    institutionsByRegionStore.fetchInstitutionsByRegion(prepareParams());
    institutionsByCountryStore.fetchInstitutionsByCountry(prepareParams());
    baselineVsImprovedByDimensionsStore.fetchBaselineVsImprovedByDimension(
        prepareParams(),
    );
    institutionsByTerritorialLevelStore.fetchInstitutionsByTerritorialLevel(
        prepareParams(),
    );
    institutionsBySectorStore.fetchInstitutionsBySector(prepareParams());
    employeesBySexStore.fetchEmployeesBySex(prepareParams());
    surveyStore.fetchInstitutionsSurveys(prepareParams());
    institutionsDirectServicesStore.fetchInstitutionsDirectService(
        prepareParams(),
    );
    dashboardSelectedFiltersStore.fetchPiCount(prepareParams());
  };

  watch(
      () => [
        dashboardSelectedFiltersStore.year,
        dashboardSelectedFiltersStore.previousYears,
        dashboardSelectedFiltersStore.status,
        dashboardSelectedFiltersStore.territorialLevel,
        dashboardSelectedFiltersStore.sector,
        dashboardSelectedFiltersStore.region,
        dashboardSelectedFiltersStore.country,
        i18n.global.locale,
      ],
      () => {
        refresh();
      },
  );

  var subheaderStore = SubHeaderStore();


  onMounted(async () => {
    if(showDashboardAsAdmin) {
      dashboardSelectedFiltersStore.setShowNonAccessibleAreas(true)
    }
    store.setTitle('label_title_summary_information')
    subheaderStore.setSubHeader(SubHeaderType.dashboard)


    await apiCall<number>("wp-json/v2/dashboard/generate-survey-combinations/", {});

    while (currentMissing.value != 0) {
      showCacheGeneration.value = true;
      try {
        currentMissing.value = await apiCall<number>("wp-json/v2/dashboard/generate-single-cache/", {});
      } catch (e) {
      }
    }

    showCacheGeneration.value = false;
    refresh();

  });
}*/
import {defineComponent} from "vue";
import WidgetContainer from "@/components/modules/new-dashboard/components/WidgetContainer.vue";
import OrganizationsByStatus from "@/components/modules/new-dashboard/components/OrganizationsByStatus.vue";
import OrganizationsByRegion
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-map-widget.vue";
import OrganizationsByRegionWidget
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-widget.vue";
import OrganizationsByRegionMapWidget
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-map-widget.vue";
import OrganizationsByTypeWidget from "@/components/modules/new-dashboard/components/organizations-by-type-widget.vue";
import EmployeesBySexWidget
  from "@/components/modules/new-dashboard/components/employees-by-sex/employees-by-sex-widget.vue";
import EmployeesByOrganizationSize
  from "@/components/modules/new-dashboard/components/employees-by-organization-size.vue";
import OrganizationsByEconomyActivity
  from "@/components/modules/new-dashboard/components/organizations-by-economic-activity/organizations-by-economic-activity.vue";
import SurveyWidget from "@/components/modules/new-dashboard/components/survey/survey-widget.vue";
import {mapGetters} from "vuex";
import Filters from "@/components/template/_template-filters.vue";
import DashboardFilters from "@/components/modules/new-dashboard/components/dashboard-filters.vue";
import DashboardSelector from "@/components/modules/new-dashboard/dashboard-selector.vue";
import {debounce} from "lodash";

export default defineComponent({
  components: {
    DashboardSelector,
    DashboardFilters,
    Filters,
    SurveyWidget,
    OrganizationsByEconomyActivity,
    EmployeesByOrganizationSize,
    EmployeesBySexWidget,
    OrganizationsByTypeWidget,
    OrganizationsByRegionMapWidget,
    OrganizationsByRegionWidget, OrganizationsByRegion, OrganizationsByStatus, WidgetContainer},
  mounted: function() {
    this.$store.commit("setFilters",{});
    this.$store.dispatch("REFRESH_DASHBOARD");
    var containerElem = this.$refs.dashboardContainer;

    if (containerElem instanceof Element) {
      this.resizeObserver = new ResizeObserver(
        debounce (()=>{
          if(containerElem.offsetWidth !== this.currentWidth){
          this.currentWidth = containerElem.offsetWidth;
          this.randomKey = Math.random().toString(36);
          }
        },100)
      );

      this.resizeObserver.observe(containerElem);
    }
  },
  data: function() {
    return {
      randomKey:1,
      resizeObserver:null,
      currentWidth:0
    }
  },
  computed: {
    ...mapGetters(['getOpinionSurveyReport','getViolenceSurveyReport','getTotalCountries','getOrganizationsByStatus',
      'getTotalOrganizations','getImpactedWorkers','getTotalOrganizationsByType','getTotalOrganizationsByOrganizationSize','getTotalOrganizationsByEconomicActivity','getTotalOrganizationsByRegion']
    )},
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
})
</script>

<template>
  <div ref="dashboardContainer" style="position: relative;">
<!--  dashboard selector -->
    <dashboard-filters></dashboard-filters>
    <div class="summary-information" id="download-screen">
      <widget-container
          title="label_dashboard_organizations_by_status_title"
          :grid-column-start="1"
          :grid-column-end="2"
          :grid-row-start="1"
          :grid-row-end="2"
      >
        <organizations-by-status :key="randomKey"></organizations-by-status>
      </widget-container>
      <widget-container
          :countries-count="getTotalCountries"
          :count="getTotalOrganizationsByRegion"
          title="label_dashboard_organizations_by_region_title"
          :grid-column-start="2"
          :grid-column-end="4"
          :grid-row-start="1"
          :grid-row-end="2"
          widget-padding="0px"
          widget-width="436px"
          inner-padding="10px 15px"

      >
        <OrganizationsByRegionWidget :key="randomKey"></OrganizationsByRegionWidget>
        <template v-slot:right>
          <organizations-by-region-map-widget :key="randomKey"></organizations-by-region-map-widget>
        </template>
      </widget-container>
      <widget-container  title="label_dashboard_impacted_workers_title" widget-padding="10px 15px 0px 15px"           :count="getImpactedWorkers.data?.total">
        <employees-by-sex-widget></employees-by-sex-widget>
      </widget-container>
      <widget-container
        :grid-column-start="2"
        :grid-column-end="4"
        :grid-row-start="2"
        :grid-row-end="3"
        title="label_dashboard_organizations_by_type_title"
        :count="getTotalOrganizationsByType"
      >
        <organizations-by-type-widget :key="randomKey"></organizations-by-type-widget>
      </widget-container>
      <widget-container :count="getTotalOrganizationsByOrganizationSize"
        title="label_dashboard_employees_by_organization_size_title"
      >
        <employees-by-organization-size :key="randomKey"></employees-by-organization-size>
      </widget-container>
      <widget-container
        title="label_dashboard_organizations_by_economic_activity_title"
        :grid-column-start="2"
        :grid-column-end="4"
        :grid-row-start="3"
        :grid-row-end="4"
        :count="getTotalOrganizationsByEconomicActivity"
      >
        <organizations-by-economy-activity :key="randomKey"></organizations-by-economy-activity>
      </widget-container>
      <widget-container
        title="label_dashboard_opinion_survey_title"
        :grid-column-start="1"
        :grid-column-end="4"
        :grid-row-start="4"
        :grid-row-end="5"
        :external-count-self="true"
        :count="getOpinionSurveyReport.data.total"
      >
        <survey-widget :survey-data="getOpinionSurveyReport" :key="randomKey"></survey-widget>
      </widget-container>
      <widget-container
        title="label_dashboard_violence_survey_title"
        :grid-column-start="1"
        :grid-column-end="4"
        :grid-row-start="5"
        :grid-row-end="6"
        :external-count-work="true"
        :count="getViolenceSurveyReport.data.total"
      >
        <survey-widget :survey-data="getViolenceSurveyReport" :key="randomKey"></survey-widget>
      </widget-container>
    </div>
  </div>
</template>
<style scoped>
.summary-information {
  padding: 30px;
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background-color: #f2f6f8;
  overflow: scroll;
  min-width: 1200px;
}
.second-grid {
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: 1fr;
}

.third-grid {
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-column-start: 2;
  grid-column-end: 4;
}
</style>
